import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { setSliceResolution } from '../../../../redux/slices/FJSliceAIPhotoEditor';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextToImageResolution from '../../../FJTextToImage/FJTextToImageLeft/view/FJTextToImageResolution';
import { AI_PHOTO_EDITOR_MODELS } from '../../../../config/dataConfig/FJAIPhotoEditorData';
import FJConstant from '../../../../constants/FJConstant.js';

const FJAIPhotoEditorResolutionContainer = memo(function FJAIPhotoEditorResolutionContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const curResolution = useSelector(state => state.aiPhotoEditor.curResolution);
    const curModel = useSelector(state => state.aiPhotoEditor.curModel);

    const changeResolution = useCallback(
        resolution => {
            dispatch(setSliceResolution(resolution));
        },
        [dispatch],
    );

    const curModelObj = useMemo(() => {
        return AI_PHOTO_EDITOR_MODELS.find(item => item.value === curModel);
    }, [curModel]);

    return (
        <FJTextToImageResolution
            curResolution={curResolution}
            changeResolution={changeResolution}
            curModelObj={curModelObj}
            boxStyle={{ marginTop: 0 }}
            type={FJConstant.FOOTER}
            placement='topLeft'
            offsetLeft={0}
            offsetTop={-4}
        />
    );
});

export default FJAIPhotoEditorResolutionContainer;
